import { errors } from 'lib_ui-primitives';
import { network, constants } from 'lib_ui-services';
import basicValidation from '../../../CRUD/namespace/relation/doingValidate_namespace_relation';

export default {
    verb: 'doingValidate',
    namespace: 'deviceManagement',
    relation: 'readerMode',
    description: 'Validate tenant Reader Mode changes before saving',
    priority: (basicValidation.priority || 0) + 5,
    logic: validate
};

async function validate({ data, dispatch }) {
    if (!(await network.getStatus()).isOnline) {
        throw new errors.ValidationError('Connect online before saving a Reader Mode.', {});
    }
    const { oldRecord, newRecord, isNew } = data;
    // Match the repository's finite, non-negative range. There is no specified
    // upper distance limit; an arbitrary client cap would prevent editing valid modes.
    // https://github.com/sstid/backbone/issues/2268
    const distance = newRecord.minimumMoveDistance;
    if (distance != null && (String(distance).trim() === '' || !Number.isFinite(Number(distance)) || Number(distance) < 0)) {
        const message = 'Minimum Movement Distance must be a non-negative number.';
        throw new errors.ValidationError(message, { minimumMoveDistance: message });
    }
    // Existing numeric records must also pass the text control's length validation.
    if (typeof distance === 'number') newRecord.minimumMoveDistance = String(distance);
    if (!isNew && oldRecord?.isDefault === true && newRecord.isDefault !== true) {
        const message = 'Choose another default Reader Mode before clearing this default.';
        throw new errors.ValidationError(message, { isDefault: message });
    }
    if (newRecord.isDefault === true && (isNew || oldRecord?.isDefault !== true)) {
        // Making this mode the default clears the previous mode's default flag and
        // changes which mode unassigned devices use. Fetch the current default from
        // the server so the confirmation names the mode that will be replaced.
        // https://github.com/sstid/backbone/issues/2268
        const { result: defaults = [] } = await dispatch(
            { query: { criteria: { searchCriteria: { isDefault: true, 'meta.deleted': { $exists: false } } } } },
            { verb: 'getFromServer', namespace: 'deviceManagement', relation: 'readerMode' },
            true
        );
        if (defaults.length !== 1) {
            throw new errors.ValidationError('Unable to load the current default Reader Mode. Reload and try again.', {});
        }
        const confirmed = await new Promise((resolve, reject) => {
            Promise.resolve(dispatch({
                message: `Replace '${defaults[0].title}' with '${newRecord.title}' as the tenant's default Reader Mode? Devices following the tenant default will use '${newRecord.title}'.`,
                okButtonText: 'YES',
                cancelButtonText: 'NO',
                icon: 'warning',
                variant: constants.VARIANT.Warning,
                okAction: () => resolve(true),
                cancelAction: () => resolve(false)
            }, { verb: 'confirm', namespace: 'application', relation: 'user' })).catch(reject);
        });
        if (!confirmed) throw new errors.ValidationError('Reader Mode default change cancelled.', {});
    }
    return data;
}
